(() => {
  if (customElements.get('pdp-coupon')) return;
  class PdpCoupon extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      this.info = this.closest('.product__info');
      this.button = this.querySelector('[data-coupon-copy]');
      this.status = this.querySelector('[data-coupon-status]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.button?.addEventListener('click', () => this.copy(), options);
      this.form?.addEventListener('variant:changed', () => this.renderPrice(), options);
      document.addEventListener('visibilitychange', () => this.checkExpiry(), options);
      this.checkExpiry();

      this.observer = new MutationObserver(mutations => {
        if (mutations.some(mutation => !this.contains(mutation.target))) this.renderPrice();
      });
      if (this.info) this.observer.observe(this.info, { subtree: true, childList: true, characterData: true });
      this.renderPrice();

    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.expiryTimer); }
    checkExpiry() {
      clearTimeout(this.expiryTimer);
      if (!this.dataset.expiresAt) return false;
      const remaining = Number(this.dataset.expiresAt) * 1000 - Date.now();
      this.hidden = !Number.isFinite(remaining) || remaining <= 0;
      if (!this.hidden) {
        this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(remaining, 2147483647));
      }
      return this.hidden;
    }
    renderPrice() {
      const priceElement = this.info?.querySelector('.price--large');
      const text = priceElement?.cloneNode(true);
      text?.querySelectorAll('.visually-hidden').forEach(el => el.remove());
      const raw = (text?.textContent || '').replace(/[^\d,.]/g, '');
      const last = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
      const decimals = last >= 0 && raw.length - last - 1 === 2;
      const normalized = decimals ? raw.slice(0, last).replace(/[,.]/g, '') + '.' + raw.slice(last + 1) : raw.replace(/[,.]/g, '');
      const cents = Math.round(Number(normalized) * 100);
      if (!raw || !Number.isFinite(cents)) return;
      const saving = Math.round(cents * Number(this.dataset.percent) / 100);
      const format = n => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: this.dataset.currency || 'BRL' }).format(n / 100);
      this.querySelector('[data-coupon-total]').textContent = format(cents - saving);
      this.querySelector('[data-coupon-savings]').textContent = format(saving);
    }
    async copy() {
      if (this.checkExpiry()) return;
      this.button.disabled = true;
      try {
        await navigator.clipboard.writeText(this.dataset.code);
        this.status.textContent = this.dataset.copied;
      } catch {
        this.status.textContent = this.dataset.copyError;
      } finally {
        this.button.disabled = false;
      }
    }
  }
  customElements.define('pdp-coupon', PdpCoupon);
})();
